module.exports = __webpack_public_path__ + "assets/img/video.b762393a.svg";